import axios, { AxiosInstance } from 'axios';
import { clearSessionOnUnauthorized } from '@/lib/clearSessionOnUnauthorized';
import { getAuth } from 'firebase/auth';

class OldClient {
  private _client: AxiosInstance;

  get client() {
    return this._client;
  }

  constructor() {
    const baseURL = process.env.NEXT_PUBLIC_OLD_BASE_API_URL;

    if (!baseURL) {
      throw Error('Environment keys for Old API client are not defined');
    }

    this._client = axios.create({
      baseURL,
      responseType: 'json',
      timeout: 10000,
    });
    this._client.interceptors.request.use(async (config) => {
      // Insert authorization bearer token into every request if it exists
      const token = await getAuth()?.currentUser?.getIdToken();
      if (token && token !== localStorage.getItem('authToken')) {
        localStorage.setItem('authToken', token);
      }

      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      };
    });
    this._client.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 401) {
          clearSessionOnUnauthorized();
          console.error('User logged out: 401 Unauthorized');
        }
        return Promise.reject(error);
      }
    );
  }
}

export const OldAPI = new OldClient().client;
